import GoogleAnalytics from 'react-ga';

export const googleAnalyticsInitialization = () => {
  GoogleAnalytics.initialize(
    process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID!,
  );
};
